
const digest = '34f5f2f4ed1a9f81cbba64bb121fb62451231277b61ddff9a2c228e013b8163f';
const classes = {"item":"_item_1vni0_1","patient":"_patient_1vni0_8","patientImage":"_patientImage_1vni0_16","patientData":"_patientData_1vni0_21","title":"_title_1vni0_26","text":"_text_1vni0_31","extra":"_extra_1vni0_35","name":"_name_1vni0_39","content":"_content_1vni0_50","red":"_red_1vni0_77","orange":"_orange_1vni0_85","green":"_green_1vni0_89","controls":"_controls_1vni0_93","link":"_link_1vni0_104"};
const css = `._item_1vni0_1 {
  display: flex;
  flex-direction: row;
  width: 100%;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._item_1vni0_1 ._patient_1vni0_8 {
  display: flex;
  border-right: 1px solid #eaedf3;
  padding: 12px 24px;
  gap: 10px;
  min-width: 350px;
  max-width: 350px;
}
._item_1vni0_1 ._patient_1vni0_8 ._patientImage_1vni0_16 {
  width: 36px;
  height: 36px;
  border-radius: 100%;
}
._item_1vni0_1 ._patient_1vni0_8 ._patientData_1vni0_21 {
  display: flex;
  gap: 12px;
  flex-direction: column;
}
._item_1vni0_1 ._patient_1vni0_8 ._patientData_1vni0_21 ._title_1vni0_26 {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
}
._item_1vni0_1 ._patient_1vni0_8 ._patientData_1vni0_21 ._text_1vni0_31 {
  color: #3e3f42;
  font-size: 14px;
}
._item_1vni0_1 ._patient_1vni0_8 ._patientData_1vni0_21 ._extra_1vni0_35 {
  display: flex;
  gap: 40px;
}
._item_1vni0_1 ._patient_1vni0_8 ._patientData_1vni0_21 ._extra_1vni0_35 ._name_1vni0_39 {
  font-size: 14px;
  color: #000000;
  display: flex;
  align-items: center;
  gap: 5px;
}
._item_1vni0_1 ._patient_1vni0_8 ._patientData_1vni0_21 ._extra_1vni0_35 ._name_1vni0_39 span {
  color: #9ea0a5;
  font-weight: 400;
}
._item_1vni0_1 ._content_1vni0_50 {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 12px 24px;
  gap: 7px;
}
._item_1vni0_1 ._content_1vni0_50 ._extra_1vni0_35 {
  display: flex;
  gap: 40px;
}
._item_1vni0_1 ._content_1vni0_50 ._title_1vni0_26 {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
}
._item_1vni0_1 ._content_1vni0_50 ._name_1vni0_39 {
  font-size: 14px;
  color: #000000;
  display: flex;
  align-items: center;
  gap: 5px;
}
._item_1vni0_1 ._content_1vni0_50 ._name_1vni0_39 span {
  color: #9ea0a5;
  font-weight: 400;
}
._item_1vni0_1 ._content_1vni0_50 ._red_1vni0_77 {
  color: #c53127;
  font-weight: 600;
}
._item_1vni0_1 ._content_1vni0_50 ._red_1vni0_77 span {
  color: #c53127;
  font-weight: 600;
}
._item_1vni0_1 ._content_1vni0_50 ._orange_1vni0_85 span {
  color: #f18200;
  font-weight: 600;
}
._item_1vni0_1 ._content_1vni0_50 ._green_1vni0_89 span {
  color: #619622;
  font-weight: 600;
}
._item_1vni0_1 ._controls_1vni0_93 {
  min-width: 230px;
  max-width: 230px;
  border-left: 1px solid #eaedf3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  gap: 12px;
}
._item_1vni0_1 ._controls_1vni0_93 ._link_1vni0_104 {
  font-size: 14px;
  font-weight: 500;
  color: #1665d8;
  text-decoration: underline;
  cursor: pointer;
  text-align: center;
}

._red_1vni0_77 {
  background: #f8dadb;
}

._orange_1vni0_85 {
  background: #fcf0e0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  